<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Users</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="userAdd()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="userList"
		[loading]="!userList"
		[globalFilterFields]="app.keys(userList)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="lastName">
					<div class="d-flex w-100">
						<div class="my-auto">
							Name (Last, First)
							<p-sortIcon field="lastName"></p-sortIcon>
						</div>

						<div class="ms-auto">
							<p-columnFilter type="text" field="tempFullName" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="email">
					<div class="d-flex w-100">
						<div class="my-auto">
							Email
							<p-sortIcon field="email"></p-sortIcon>
						</div>

						<div class="ms-auto">
							<p-columnFilter type="text" field="email" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="organization">
					<div class="d-flex w-100">
						<div class="my-auto">
							Organization
							<p-sortIcon field="organization"></p-sortIcon>
						</div>

						<div class="ms-auto">
							<p-columnFilter type="text" field="organization" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="status">
					<div class="d-flex w-100">
						<div class="my-auto">
							Status
							<p-sortIcon field="status"></p-sortIcon>
						</div>

						<div class="ms-auto">
							<p-columnFilter type="text" field="deviceName" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="role">
					<div class="d-flex w-100">
						<div class="my-auto">
							Role
							<p-sortIcon field="role"></p-sortIcon>
						</div>

						<div class="ms-auto">
							<p-columnFilter
								field="role"
								matchMode="in"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
								class="ms-auto"
							>
								<ng-template pTemplate="header">
									<div class="px-3 pt-3 pb-0">User Role Select</div>
								</ng-template>
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-multiSelect
										[ngModel]="value"
										[options]="userRoles"
										placeholder="Any"
										(onChange)="filter($event.value)"
										optionLabel="label"
										optionValue="value"
									>
									</p-multiSelect>
								</ng-template>
							</p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="lastLogin">
					<div class="d-flex w-100">
						<div class="my-auto">
							Last Login
							<p-sortIcon field="lastLogin"></p-sortIcon>
						</div>

						<div class="ms-auto">
							<p-columnFilter type="date" field="lastLogin" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="userSelected = rec; userEdit()">
				<td>{{ rec.lastName }}, {{ rec.firstName }}</td>
				<td class="overflow-scroll">{{ rec.email }}</td>
				<td>{{ rec.organization }}</td>
				<td>
					<span *ngIf="rec.status === 1">Active</span>
					<span *ngIf="rec.status === 2">Frozen</span>
					<span *ngIf="rec.status === 3">Deleted</span>
					<span *ngIf="rec.status === 4">Super Admin</span>
					<span *ngIf="rec.status === 5">Pending Activation</span>
					<span *ngIf="rec.status === 6">Password Reset Requested</span>
				</td>
				<td>
					<span *ngIf="rec.role === 1">Venue User</span>
					<span *ngIf="rec.role === 2">Venue Admin</span>
					<span *ngIf="rec.role === 3">Dealer User</span>
					<span *ngIf="rec.role === 4">Dealer Admin</span>
					<span *ngIf="rec.role === 5">System Admin</span>
					<span *ngIf="rec.role === 6">
						<span *ngIf="rec.firstName === 'Brandon'">His</span>
						<span *ngIf="rec.firstName === 'Julie'">Her</span>
						Holiness</span
					>
				</td>
				<td>
					<span *ngIf="rec.lastLogin"> {{ moment(rec.lastLogin).format("l LT") }} ({{ rec.loginCount }}) </span>
					<span *ngIf="!rec.lastLogin"> Never </span>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-user-detail
	*ngIf="userSelected"
	[(user)]="userSelected"
	[dealerList]="dealers"
	[venueSelectionsAvailable]="venueSelectionsAvailable"
	(onCloseChange)="userSelected = undefined"
	(userDeleteChange)="userDelete($event)"
></app-user-detail>
